import { PageId } from 'constants/pages'
import { isEmpty } from 'lodash'
import { TAnswers } from 'models/common.model'
import { getImplicitBehaviorIssuesK9 } from 'nove8/cohorts/woofz_k9/helpers/getImplicitBehaviorIssuesK9'
import { getImplicitBehaviorIssuesK9Bl } from 'nove8/cohorts/woofz_k9_bl/helpers/getImplicitBehaviorIssuesK9'
import { getImplicitBehaviorIssuesK9BlBG } from 'nove8/cohorts/woofz_k9_bl_bg/helpers/getImplicitBehaviorIssuesK9'
import { getImplicitBehaviorIssuesK9Drsl } from 'nove8/cohorts/woofz_k9_drsl/helpers/getImplicitBehaviorIssuesK9'
import { NO_ISSUES_VARIANTS } from 'nove8/constants/root-constants'
import { AnswerKey, NONE } from 'root-constants'

type TDogProblemAnswer = string | string[]

const DOG_PROBLEM_INCLUDED_PAGE_IDS: string[] = [
  PageId.CHALLENGES_PN,
  PageId.BIGGEST_CHALLENGE_PN,
  PageId.POTTY_V9,
  PageId.FACING_CHALLENGES_WOOFZ_PPP,
  PageId.FACING_CHALLENGES_2_WOOFZ_PPP,
  PageId.FACING_CHALLENGES_WOOFZ_PPP_BL,
  PageId.FACING_CHALLENGES_2_WOOFZ_PPP_BL,
  PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY,
  PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY,
  PageId.FACING_CHALLENGES_PUP,
  PageId.FACING_CHALLENGES_2_PUP,
  PageId.FACING_CHALLENGES_PUP_WT,
  PageId.FACING_CHALLENGES_2_PUP_WT,
  PageId.FACING_CHALLENGES_PUP_BL,
  PageId.FACING_CHALLENGES_2_PUP_BL,
  PageId.FACING_CHALLENGES_PUP_DRSL,
  PageId.FACING_CHALLENGES_2_PUP_DRSL,
]

const DOG_PROBLEM_SKIPPED_PAGE_IDS: string[] = [
  PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP,
  PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP,
  PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_BL,
  PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_BL,
  PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY,
  PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY,
  PageId.BEHAVIOR_LOVE,
  PageId.BEHAVIOR_LOVE_BL,
  PageId.BEHAVIOR_FEELINGS_PUP,
  PageId.BEHAVIOR_FREQUENCY_PUP,
  PageId.BEHAVIOR_FEELINGS_PUP_WT,
  PageId.BEHAVIOR_FREQUENCY_PUP_WT,
  PageId.BEHAVIOR_FEELINGS_PUP_BL,
  PageId.BEHAVIOR_FREQUENCY_PUP_BL,
  PageId.BEHAVIOR_FEELINGS_PUP_DRSL,
  PageId.BEHAVIOR_FREQUENCY_PUP_DRSL,
]

const isDogProblemAnswerPage = (pageId: string) =>
  (pageId.startsWith(AnswerKey.BEHAVIOR) ||
    DOG_PROBLEM_INCLUDED_PAGE_IDS.includes(pageId)) &&
  !DOG_PROBLEM_SKIPPED_PAGE_IDS.includes(pageId)

const isNoDogProblemAnswer = (answer: TDogProblemAnswer) =>
  answer === NONE ||
  (Array.isArray(answer) &&
    (answer[0] === NONE || NO_ISSUES_VARIANTS.includes(answer[0])))

export const getDogProblemFromSavedAnswers = (
  answers: Partial<TAnswers> | null,
): TDogProblemAnswer => {
  if (!answers || isEmpty(answers)) return ''

  let hasNoDogProblemAnswer = false

  const dogProblems = Object.entries(answers).reduce<string[]>(
    (acc, [pageId, answer]) => {
      if (!isDogProblemAnswerPage(pageId)) return acc

      if (isNoDogProblemAnswer(answer)) {
        hasNoDogProblemAnswer = true
        return acc
      }

      return [...acc, ...(Array.isArray(answer) ? answer : [answer])]
    },
    [],
  )

  const implicitK9 = [
    ...getImplicitBehaviorIssuesK9(answers),
    ...getImplicitBehaviorIssuesK9Bl(answers),
    ...getImplicitBehaviorIssuesK9BlBG(answers),
    ...getImplicitBehaviorIssuesK9Drsl(answers),
  ]

  const allProblems = [...new Set([...dogProblems, ...implicitK9])]

  if (allProblems.length) return allProblems

  return hasNoDogProblemAnswer ? NONE : ''
}
